import { render } from "./secondstepGroomingView.vue?vue&type=template&id=6d361e8c&scoped=true"
import script from "./secondstepGroomingView.vue?vue&type=script&lang=js"
export * from "./secondstepGroomingView.vue?vue&type=script&lang=js"

import "./secondstepGroomingView.vue?vue&type=style&index=0&id=6d361e8c&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d361e8c"]])

export default __exports__